import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function automationRequestReducer(state = initialstate.automationRequest, action) {
	switch (action.type) {
		case types.GET_AUTOMATION_REQUEST:
			if(action.error) {
				return [];
			}
			let updateState =  _.size(action.response) > 0 ? action.response.sort(function(a, b) {
				return a.serviceRequestName.localeCompare(b.serviceRequestName);
				}) : [];

			return updateState;
		default:
			return state;
	}
}
